import { ChatView } from "./_components";

export default function ChatPage() {
  return <ChatView />;
}
